import { cn } from "@/lib/utils";
import { Loader2, type LucideProps } from "lucide-react";

export type Icon = (props: LucideProps) => JSX.Element;

export const ArrowCircleDown: Icon = (props) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.06 11.27L12.53 14.8C12.38 14.95 12.19 15.02 12 15.02C11.81 15.02 11.62 14.95 11.47 14.8L7.94 11.27C7.65 10.98 7.65 10.5 7.94 10.21C8.23 9.92 8.71 9.92 9 10.21L12 13.21L15 10.21C15.29 9.92 15.77 9.92 16.06 10.21C16.35 10.5 16.35 10.97 16.06 11.27Z"
                fill="#1066AF"
            />
        </svg>
    );
};

export const GreyLock: Icon = (props) => {
    return (
        <svg
            width="17"
            height="20"
            viewBox="0 0 17 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M15.9654 9.48865C15.7001 9.22348 15.3783 9.09099 14.9993 9.09099H14.545V6.36356C14.545 4.62117 13.9202 3.12509 12.6702 1.87508C11.4202 0.625028 9.92428 0 8.18163 0C6.43904 0 4.94281 0.625028 3.69295 1.87503C2.4429 3.12509 1.81807 4.62112 1.81807 6.36356V9.09099H1.36359C0.98493 9.09099 0.662889 9.22348 0.397713 9.48865C0.132538 9.75363 0 10.0757 0 10.4547V18.6364C0 19.0151 0.132588 19.3372 0.397713 19.6024C0.662889 19.8674 0.98493 20 1.36359 20H14.9997C15.3786 20 15.7004 19.8675 15.9657 19.6024C16.2306 19.3372 16.3634 19.0151 16.3634 18.6364V10.4545C16.3636 10.0758 16.2306 9.75383 15.9654 9.48865ZM11.8179 9.09099H4.54535V6.36356C4.54535 5.35983 4.90052 4.50276 5.61072 3.79266C6.32103 3.08245 7.17795 2.72743 8.18178 2.72743C9.18572 2.72743 10.0424 3.0824 10.7528 3.79266C11.4628 4.50271 11.8179 5.35983 11.8179 6.36356V9.09099Z"
                fill="#A49D9D"
            />
        </svg>
    );
};

export const BlueBook: Icon = (props) => {
    return (
        <svg
            width="30"
            height="20"
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M13.6189 0C15.63 0 17.2617 1.67969 17.2617 3.75V16.25C17.2617 18.3203 15.63 20 13.6189 20H1.476C0.804353 20 0.261719 19.4414 0.261719 18.75C0.261719 18.0586 0.804353 17.5 1.476 17.5V15C0.804353 15 0.261719 14.4414 0.261719 13.75V1.25C0.261719 0.558594 0.804353 0 1.476 0H2.69029H13.6189ZM13.6189 15H3.90458V17.5H13.6189C14.2905 17.5 14.8331 16.9414 14.8331 16.25C14.8331 15.5586 14.2905 15 13.6189 15ZM12.4046 5.625C12.4046 5.28125 12.1314 5 11.7974 5H4.51172C4.17779 5 3.90458 5.28125 3.90458 5.625C3.90458 5.96875 4.17779 6.25 4.51172 6.25H11.7974C12.1314 6.25 12.4046 5.96875 12.4046 5.625ZM11.7974 7.5H4.51172C4.17779 7.5 3.90458 7.78125 3.90458 8.125C3.90458 8.46875 4.17779 8.75 4.51172 8.75H11.7974C12.1314 8.75 12.4046 8.46875 12.4046 8.125C12.4046 7.78125 12.1314 7.5 11.7974 7.5Z"
                fill="#1066AF"
            />
        </svg>
    );
};

export const BlueVideoFill: Icon = (props) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5 17.5C11.4849 17.5 12.4602 17.306 13.3701 16.9291C14.2801 16.5522 15.1069 15.9997 15.8033 15.3033C16.4997 14.6069 17.0522 13.7801 17.4291 12.8701C17.806 11.9602 18 10.9849 18 10C18 9.01509 17.806 8.03982 17.4291 7.12987C17.0522 6.21993 16.4997 5.39314 15.8033 4.6967C15.1069 4.00026 14.2801 3.44781 13.3701 3.0709C12.4602 2.69399 11.4849 2.5 10.5 2.5C8.51088 2.5 6.60322 3.29018 5.1967 4.6967C3.79018 6.10322 3 8.01088 3 10C3 11.9891 3.79018 13.8968 5.1967 15.3033C6.60322 16.7098 8.51088 17.5 10.5 17.5ZM9.48583 6.65833L14.1892 9.27167C14.319 9.34386 14.4272 9.44945 14.5025 9.57751C14.5778 9.70557 14.6176 9.85143 14.6176 10C14.6176 10.1486 14.5778 10.2944 14.5025 10.4225C14.4272 10.5505 14.319 10.6561 14.1892 10.7283L9.48583 13.3417C9.33354 13.4263 9.16177 13.4697 8.98755 13.4675C8.81333 13.4654 8.64269 13.4177 8.49256 13.3293C8.34242 13.2409 8.21799 13.1148 8.13159 12.9635C8.0452 12.8122 7.99983 12.6409 8 12.4667V7.53333C7.99983 7.3591 8.0452 7.18784 8.13159 7.03653C8.21799 6.88522 8.34242 6.75911 8.49256 6.6707C8.64269 6.58228 8.81333 6.53463 8.98755 6.53246C9.16177 6.53029 9.33354 6.57368 9.48583 6.65833Z"
                fill="#1066AF"
            />
        </svg>
    );
};
export const GreyVideoFill: Icon = (props) => {
    return (
        <svg
            width="22"
            height="25"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5 17.5C11.4849 17.5 12.4602 17.306 13.3701 16.9291C14.2801 16.5522 15.1069 15.9997 15.8033 15.3033C16.4997 14.6069 17.0522 13.7801 17.4291 12.8701C17.806 11.9602 18 10.9849 18 10C18 9.01509 17.806 8.03982 17.4291 7.12987C17.0522 6.21993 16.4997 5.39314 15.8033 4.6967C15.1069 4.00026 14.2801 3.44781 13.3701 3.0709C12.4602 2.69399 11.4849 2.5 10.5 2.5C8.51088 2.5 6.60322 3.29018 5.1967 4.6967C3.79018 6.10322 3 8.01088 3 10C3 11.9891 3.79018 13.8968 5.1967 15.3033C6.60322 16.7098 8.51088 17.5 10.5 17.5ZM9.48583 6.65833L14.1892 9.27167C14.319 9.34386 14.4272 9.44945 14.5025 9.57751C14.5778 9.70557 14.6176 9.85143 14.6176 10C14.6176 10.1486 14.5778 10.2944 14.5025 10.4225C14.4272 10.5505 14.319 10.6561 14.1892 10.7283L9.48583 13.3417C9.33354 13.4263 9.16177 13.4697 8.98755 13.4675C8.81333 13.4654 8.64269 13.4177 8.49256 13.3293C8.34242 13.2409 8.21799 13.1148 8.13159 12.9635C8.0452 12.8122 7.99983 12.6409 8 12.4667V7.53333C7.99983 7.3591 8.0452 7.18784 8.13159 7.03653C8.21799 6.88522 8.34242 6.75911 8.49256 6.6707C8.64269 6.58228 8.81333 6.53463 8.98755 6.53246C9.16177 6.53029 9.33354 6.57368 9.48583 6.65833Z"
                fill="#A9A9A9"
                stroke="#FCFCFC"
            />
        </svg>
    );
};
export const GreyScreen: Icon = (props) => {
    return (
        <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clip-path="url(#clip0_155_2528)">
                <path
                    d="M11.7536 16.85C11.9421 16.8491 12.1268 16.7961 12.2872 16.697C12.4483 16.5975 12.5786 16.4553 12.6638 16.2863L12.6641 16.2857C12.7856 16.0436 12.8064 15.7632 12.7219 15.5059C12.6374 15.2485 12.4545 15.0351 12.2131 14.9122L12.2102 14.9107L10.6308 14.1196C10.7302 14.0707 10.821 14.0059 10.8999 13.9278L10.902 13.9257L12.1729 12.65H14.375C14.9253 12.65 15.4531 12.4314 15.8422 12.0423C16.2314 11.6531 16.45 11.1253 16.45 10.575V3.22502C16.45 2.6747 16.2314 2.14692 15.8422 1.75778C15.4531 1.36864 14.9253 1.15002 14.375 1.15002H2.825C2.27468 1.15002 1.74689 1.36864 1.35775 1.75778C0.968616 2.14692 0.75 2.6747 0.75 3.22502V10.575C0.75 11.1253 0.968615 11.6531 1.35775 12.0423C1.74689 12.4314 2.27468 12.65 2.825 12.65H5.0271L6.29804 13.9257L6.29804 13.9257L6.30014 13.9278C6.37896 14.0059 6.46985 14.0707 6.56917 14.1196L4.98981 14.9107L4.97253 14.9194L4.95596 14.9294C4.7342 15.0628 4.57113 15.2752 4.49949 15.5239C4.42784 15.7726 4.45293 16.0392 4.56971 16.2701C4.68649 16.5011 4.88631 16.6793 5.12907 16.769C5.37183 16.8588 5.63954 16.8533 5.87846 16.7539L5.8942 16.7473L5.90946 16.7397L7.72501 15.8339C7.76699 15.9027 7.81728 15.9669 7.87522 16.0248C8.06744 16.217 8.32815 16.325 8.6 16.325C8.87185 16.325 9.13256 16.217 9.32478 16.0248C9.38272 15.9669 9.43301 15.9027 9.47499 15.8339L11.2852 16.737C11.4296 16.8127 11.5905 16.8516 11.7536 16.85ZM11.7536 16.85C11.7529 16.85 11.7522 16.85 11.7515 16.85L11.75 16.35L11.756 16.85C11.7552 16.85 11.7544 16.85 11.7536 16.85ZM10.175 13.725H9.84313L10.174 13.8908L10.175 13.725ZM10.175 13.725V13.8913M10.175 13.725V13.8913M10.175 13.8913V14.225H10.1739H9.7249L11.9862 15.3578C12.1099 15.4207 12.2036 15.53 12.2469 15.6619C12.2902 15.7937 12.2795 15.9373 12.2172 16.0613L10.175 13.8913ZM10.3766 13.6861L10.5338 14.071L10.5338 14.071L10.3766 13.6861ZM4.90732 8.98235L4.55377 8.62879L4.90732 8.98235C4.91201 8.97766 4.91837 8.97502 4.925 8.97502H10.175C10.1816 8.97502 10.188 8.97766 10.1927 8.98235C10.1974 8.98703 10.2 8.99339 10.2 9.00002C10.2 9.00666 10.1974 9.01301 10.1927 9.0177C10.188 9.02239 10.1816 9.02502 10.175 9.02502H4.925C4.91837 9.02502 4.91201 9.02239 4.90732 9.0177L4.59796 9.32706L4.90732 9.0177C4.90263 9.01301 4.9 9.00666 4.9 9.00002C4.9 8.99339 4.90263 8.98704 4.90732 8.98235ZM4.9 6.90002C4.9 6.89339 4.90263 6.88703 4.90732 6.88235L4.55377 6.52879L4.90732 6.88235C4.91201 6.87766 4.91837 6.87502 4.925 6.87502H7.55C7.55663 6.87502 7.56299 6.87766 7.56768 6.88235C7.57237 6.88704 7.575 6.89339 7.575 6.90002C7.575 6.90665 7.57237 6.91301 7.56768 6.9177C7.56299 6.92239 7.55663 6.92502 7.55 6.92502H4.925C4.91837 6.92502 4.91201 6.92239 4.90732 6.9177L4.55377 7.27126L4.90732 6.9177C4.90263 6.91301 4.9 6.90665 4.9 6.90002ZM12.275 4.82502H4.925C4.91837 4.82502 4.91201 4.82239 4.90732 4.8177C4.90263 4.81301 4.9 4.80665 4.9 4.80002C4.9 4.79339 4.90263 4.78704 4.90732 4.78235C4.91201 4.77766 4.91837 4.77502 4.925 4.77502H12.275C12.2816 4.77502 12.288 4.77766 12.2927 4.78235C12.2974 4.78703 12.3 4.79339 12.3 4.80002C12.3 4.80666 12.2974 4.81301 12.2927 4.8177C12.288 4.82239 12.2816 4.82502 12.275 4.82502Z"
                    fill="#A9A9A9"
                    stroke="#FCFCFC"
                />
            </g>
            <defs>
                <clipPath id="clip0_155_2528">
                    <rect
                        width="16.8"
                        height="16.8"
                        fill="white"
                        transform="translate(0.200195 0.599976)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const BlueScreen: Icon = (props) => {
    return (
        <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clip-path="url(#clip0_155_2528)">
                <path
                    d="M11.7536 16.85C11.9421 16.8491 12.1268 16.7961 12.2872 16.697C12.4483 16.5975 12.5786 16.4553 12.6638 16.2863L12.6641 16.2857C12.7856 16.0436 12.8064 15.7632 12.7219 15.5059C12.6374 15.2485 12.4545 15.0351 12.2131 14.9122L12.2102 14.9107L10.6308 14.1196C10.7302 14.0707 10.821 14.0059 10.8999 13.9278L10.902 13.9257L12.1729 12.65H14.375C14.9253 12.65 15.4531 12.4314 15.8422 12.0423C16.2314 11.6531 16.45 11.1253 16.45 10.575V3.22502C16.45 2.6747 16.2314 2.14692 15.8422 1.75778C15.4531 1.36864 14.9253 1.15002 14.375 1.15002H2.825C2.27468 1.15002 1.74689 1.36864 1.35775 1.75778C0.968616 2.14692 0.75 2.6747 0.75 3.22502V10.575C0.75 11.1253 0.968615 11.6531 1.35775 12.0423C1.74689 12.4314 2.27468 12.65 2.825 12.65H5.0271L6.29804 13.9257L6.29804 13.9257L6.30014 13.9278C6.37896 14.0059 6.46985 14.0707 6.56917 14.1196L4.98981 14.9107L4.97253 14.9194L4.95596 14.9294C4.7342 15.0628 4.57113 15.2752 4.49949 15.5239C4.42784 15.7726 4.45293 16.0392 4.56971 16.2701C4.68649 16.5011 4.88631 16.6793 5.12907 16.769C5.37183 16.8588 5.63954 16.8533 5.87846 16.7539L5.8942 16.7473L5.90946 16.7397L7.72501 15.8339C7.76699 15.9027 7.81728 15.9669 7.87522 16.0248C8.06744 16.217 8.32815 16.325 8.6 16.325C8.87185 16.325 9.13256 16.217 9.32478 16.0248C9.38272 15.9669 9.43301 15.9027 9.47499 15.8339L11.2852 16.737C11.4296 16.8127 11.5905 16.8516 11.7536 16.85ZM11.7536 16.85C11.7529 16.85 11.7522 16.85 11.7515 16.85L11.75 16.35L11.756 16.85C11.7552 16.85 11.7544 16.85 11.7536 16.85ZM10.175 13.725H9.84313L10.174 13.8908L10.175 13.725ZM10.175 13.725V13.8913M10.175 13.725V13.8913M10.175 13.8913V14.225H10.1739H9.7249L11.9862 15.3578C12.1099 15.4207 12.2036 15.53 12.2469 15.6619C12.2902 15.7937 12.2795 15.9373 12.2172 16.0613L10.175 13.8913ZM10.3766 13.6861L10.5338 14.071L10.5338 14.071L10.3766 13.6861ZM4.90732 8.98235L4.55377 8.62879L4.90732 8.98235C4.91201 8.97766 4.91837 8.97502 4.925 8.97502H10.175C10.1816 8.97502 10.188 8.97766 10.1927 8.98235C10.1974 8.98703 10.2 8.99339 10.2 9.00002C10.2 9.00666 10.1974 9.01301 10.1927 9.0177C10.188 9.02239 10.1816 9.02502 10.175 9.02502H4.925C4.91837 9.02502 4.91201 9.02239 4.90732 9.0177L4.59796 9.32706L4.90732 9.0177C4.90263 9.01301 4.9 9.00666 4.9 9.00002C4.9 8.99339 4.90263 8.98704 4.90732 8.98235ZM4.9 6.90002C4.9 6.89339 4.90263 6.88703 4.90732 6.88235L4.55377 6.52879L4.90732 6.88235C4.91201 6.87766 4.91837 6.87502 4.925 6.87502H7.55C7.55663 6.87502 7.56299 6.87766 7.56768 6.88235C7.57237 6.88704 7.575 6.89339 7.575 6.90002C7.575 6.90665 7.57237 6.91301 7.56768 6.9177C7.56299 6.92239 7.55663 6.92502 7.55 6.92502H4.925C4.91837 6.92502 4.91201 6.92239 4.90732 6.9177L4.55377 7.27126L4.90732 6.9177C4.90263 6.91301 4.9 6.90665 4.9 6.90002ZM12.275 4.82502H4.925C4.91837 4.82502 4.91201 4.82239 4.90732 4.8177C4.90263 4.81301 4.9 4.80665 4.9 4.80002C4.9 4.79339 4.90263 4.78704 4.90732 4.78235C4.91201 4.77766 4.91837 4.77502 4.925 4.77502H12.275C12.2816 4.77502 12.288 4.77766 12.2927 4.78235C12.2974 4.78703 12.3 4.79339 12.3 4.80002C12.3 4.80666 12.2974 4.81301 12.2927 4.8177C12.288 4.82239 12.2816 4.82502 12.275 4.82502Z"
                    fill="#1066AF"
                    stroke="#FCFCFC"
                />
            </g>
            <defs>
                <clipPath id="clip0_155_2528">
                    <rect
                        width="16.8"
                        height="16.8"
                        fill="white"
                        transform="translate(0.200195 0.599976)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const GreyStar: Icon = (props) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.4597 1.81434L11.9403 4.79539C12.1398 5.20766 12.6753 5.59879 13.1269 5.68336L15.8046 6.12735C17.5162 6.41277 17.9152 7.66016 16.6866 8.90755L14.597 11.0112C14.2505 11.36 14.0509 12.0472 14.1665 12.544L14.765 15.1445C15.2375 17.1953 14.1454 17.9987 12.3498 16.9205L9.84016 15.4194C9.38862 15.1445 8.63257 15.1445 8.18104 15.4194L5.67137 16.9205C3.87575 17.9881 2.78367 17.1953 3.25621 15.1445L3.85475 12.544C3.94925 12.0366 3.74974 11.3495 3.40322 11.0006L1.31357 8.89698C0.0849888 7.66016 0.484016 6.41277 2.19563 6.11678L4.87332 5.67279C5.32485 5.59879 5.86038 5.19709 6.0599 4.78482L7.5405 1.80376C8.34905 0.196955 9.65114 0.196955 10.4597 1.81434Z"
                fill="#A9A9A9"
            />
        </svg>
    );
};
export const BlueStar: Icon = (props) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.4597 1.81434L11.9403 4.79539C12.1398 5.20766 12.6753 5.59879 13.1269 5.68336L15.8046 6.12735C17.5162 6.41277 17.9152 7.66016 16.6866 8.90755L14.597 11.0112C14.2505 11.36 14.0509 12.0472 14.1665 12.544L14.765 15.1445C15.2375 17.1953 14.1454 17.9987 12.3498 16.9205L9.84016 15.4194C9.38862 15.1445 8.63257 15.1445 8.18104 15.4194L5.67137 16.9205C3.87575 17.9881 2.78367 17.1953 3.25621 15.1445L3.85475 12.544C3.94925 12.0366 3.74974 11.3495 3.40322 11.0006L1.31357 8.89698C0.0849888 7.66016 0.484016 6.41277 2.19563 6.11678L4.87332 5.67279C5.32485 5.59879 5.86038 5.19709 6.0599 4.78482L7.5405 1.80376C8.34905 0.196955 9.65114 0.196955 10.4597 1.81434Z"
                fill="#1066AF"
            />
        </svg>
    );
};

export const BlackkInfinity: Icon = (props) => {
    return (
        <svg
            width="22"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M18.1123 6.1123C17.1144 6.1123 16.1295 6.3667 15.2635 6.84716C14.7811 7.11402 14.3391 7.44716 13.9488 7.8374L11.9998 9.78646L10.0502 7.83693C9.66 7.4467 9.21745 7.11356 8.73792 6.84862C7.87008 6.3667 6.88462 6.1123 5.88769 6.1123C2.64094 6.1123 0 8.75376 0 12C0 15.2467 2.64094 17.8877 5.88769 17.8877C6.88514 17.8877 7.87055 17.6328 8.73506 17.1528C9.21745 16.8869 9.66 16.5533 10.0507 16.1626L11.9999 14.2134L13.9493 16.1626C14.34 16.5543 14.7831 16.8874 15.2616 17.1519C16.1285 17.6333 17.1144 17.8877 18.1123 17.8877C21.3585 17.8877 24 15.2467 24 12C24 8.75376 21.3585 6.1123 18.1123 6.1123ZM7.83745 13.9488C7.65408 14.1321 7.44722 14.2881 7.21875 14.4139C6.8093 14.6419 6.36098 14.7571 5.88769 14.7571C4.36753 14.7571 3.13055 13.5202 3.13055 12C3.13055 10.4798 4.36748 9.24285 5.88769 9.24285C6.36098 9.24285 6.8093 9.35854 7.22114 9.58701C7.44675 9.71132 7.65413 9.86779 7.83745 10.0507L9.78623 12L7.83745 13.9488ZM18.1123 14.7576C17.6385 14.7576 17.1902 14.6424 16.7775 14.413C16.5528 14.2891 16.3464 14.1331 16.1626 13.9493L14.2138 12L16.1631 10.0512C16.3459 9.86784 16.5528 9.71184 16.7804 9.58607C17.1903 9.35901 17.6386 9.24337 18.1124 9.24337C19.633 9.24337 20.8695 10.4803 20.8695 12.0005C20.8695 13.5207 19.6329 14.7576 18.1123 14.7576Z"
                fill="#414141"
            />
        </svg>
    );
};

export const BlackPhone: Icon = (props) => {
    return (
        <svg
            width="20"
            height="26"
            viewBox="0 0 16 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.3069 0H3.65597C2.12928 0.00173118 0.89214 1.23888 0.890625 2.76556V23.2346C0.89214 24.7613 2.12928 25.9984 3.65597 25.9999H12.3069C13.8336 25.9984 15.0707 24.7613 15.0724 23.2346V2.76556C15.0707 1.23888 13.8336 0.00173118 12.3069 0ZM7.98153 23.6364C7.32866 23.6364 6.79957 23.1073 6.79957 22.4545C6.79957 21.8018 7.32866 21.2727 7.98153 21.2727C8.63419 21.2727 9.16328 21.8018 9.16328 22.4545C9.16328 23.1073 8.63419 23.6364 7.98153 23.6364ZM9.75426 3.54545H6.20881C5.88248 3.54545 5.61783 3.2808 5.61783 2.95447C5.61783 2.62815 5.88248 2.36371 6.20881 2.36371H9.75426C10.0806 2.36371 10.345 2.62815 10.345 2.95447C10.345 3.2808 10.0806 3.54545 9.75426 3.54545Z"
                fill="#414141"
            />
        </svg>
    );
};

export const Spinner = (props: LucideProps) => {
    return (
        <Loader2
            {...props}
            className={cn("w-4 h4 animate-spin", props.className)}
        />
    );
};
export const PinkEllipse: Icon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            {...props}
        >
            <circle cx="13" cy="13" r="13" fill="#FF92B8" />
        </svg>
    );
};

export const BlueEllipse: Icon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            {...props}
        >
            <circle cx="13" cy="13" r="13" fill="#1066AF" />
        </svg>
    );
};

export const GreenEllipse: Icon = (props) => {
    return (
        <svg
            width="35"
            height="35"
            viewBox="0 0 35 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="17.5" cy="17.5" r="17.5" fill="#8EFFEE" />
        </svg>
    );
};

export const LandingCertificate: Icon = (props) => {
    return (
        <svg
            width="55"
            height="55"
            viewBox="0 0 55 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle
                cx="27.5"
                cy="27.5"
                r="27.5"
                fill="url(#paint0_linear_96_4205)"
            />
            <path
                d="M26.0415 16.9413C26.654 16.6507 27.3235 16.5 28.0015 16.5C28.6794 16.5 29.3489 16.6507 29.9615 16.9413L41.3341 22.329C41.5322 22.4227 41.6999 22.5704 41.818 22.7551C41.9361 22.9397 41.9997 23.1539 42.0017 23.3731C42.0036 23.5923 41.9438 23.8076 41.829 23.9943C41.7143 24.181 41.5492 24.3317 41.3528 24.429L30.0361 30.043C29.4039 30.3571 28.7075 30.5205 28.0015 30.5205C27.2955 30.5205 26.5991 30.3571 25.9668 30.043L16.3348 25.2643V30.5003C16.3348 30.8097 16.2119 31.1065 15.9931 31.3252C15.7743 31.544 15.4776 31.667 15.1681 31.667C14.8587 31.667 14.562 31.544 14.3432 31.3252C14.1244 31.1065 14.0015 30.8097 14.0015 30.5003V23.442C13.99 23.2112 14.0473 22.9823 14.1661 22.7841C14.2849 22.586 14.4599 22.4276 14.6688 22.329L26.0415 16.9413ZM18.6681 29.028V32.8336C18.6682 32.9871 18.6985 33.1391 18.7573 33.2808C18.8162 33.4225 18.9024 33.5513 19.0111 33.6596L19.0158 33.6666L19.0695 33.7156L19.2095 33.8463C19.3261 33.9552 19.4949 34.1006 19.7158 34.2826C20.1521 34.6396 20.7821 35.111 21.5685 35.5846C23.1318 36.5203 25.3811 37.5003 28.0015 37.5003C30.6218 37.5003 32.8735 36.5203 34.4345 35.5846C35.2743 35.0804 36.0649 34.4984 36.7958 33.8463L36.9358 33.7156L36.9731 33.6783L36.9871 33.6643L36.9895 33.662L36.9941 33.6596C37.1024 33.5511 37.1882 33.4223 37.2467 33.2805C37.3051 33.1388 37.3351 32.9869 37.3348 32.8336V29.0256L31.0721 32.1336C30.1178 32.6073 29.0669 32.8538 28.0015 32.8538C26.9361 32.8538 25.8851 32.6073 24.9308 32.1336L18.6681 29.028Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_96_4205"
                    x1="28"
                    y1="55"
                    x2="24.5"
                    y2="-56.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#D60A53" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const LandingShortCourses: Icon = (props) => {
    return (
        <svg
            width="55"
            height="55"
            viewBox="0 0 55 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle
                cx="27.5"
                cy="27.5"
                r="27.5"
                fill="url(#paint0_linear_96_4212)"
            />
            <path
                d="M23.8213 19.9023C21.916 18.9926 19.2529 18.547 15.6875 18.5312C15.3513 18.5266 15.0216 18.6247 14.7425 18.8123C14.5134 18.9671 14.3259 19.1759 14.1964 19.4202C14.067 19.6645 13.9995 19.9369 14 20.2134V35.3007C14 36.3206 14.7256 37.09 15.6875 37.09C19.4353 37.09 23.1948 37.4402 25.4465 39.5685C25.4773 39.5978 25.516 39.6173 25.5579 39.6248C25.5997 39.6322 25.6428 39.6272 25.6818 39.6103C25.7208 39.5934 25.7539 39.5655 25.7772 39.53C25.8004 39.4944 25.8127 39.4528 25.8125 39.4103V21.633C25.8126 21.5131 25.7869 21.3945 25.7372 21.2854C25.6875 21.1762 25.615 21.079 25.5246 21.0002C25.0088 20.5593 24.4358 20.19 23.8213 19.9023ZM38.57 18.8107C38.2908 18.6236 37.9611 18.5261 37.625 18.5312C34.0596 18.547 31.3965 18.9905 29.4913 19.9023C28.8767 20.1894 28.3036 20.558 27.7874 20.9981C27.6971 21.077 27.6248 21.1743 27.5752 21.2834C27.5256 21.3926 27.5 21.511 27.5 21.6309V39.4093C27.5 39.4501 27.512 39.49 27.5346 39.524C27.5572 39.558 27.5893 39.5846 27.6269 39.6004C27.6645 39.6163 27.706 39.6206 27.7461 39.613C27.7862 39.6053 27.8231 39.586 27.8523 39.5574C29.206 38.2127 31.5816 37.0884 37.6271 37.089C38.0747 37.089 38.5039 36.9112 38.8204 36.5947C39.1368 36.2782 39.3146 35.849 39.3146 35.4015V20.214C39.3152 19.9369 39.2476 19.664 39.1178 19.4192C38.9879 19.1745 38.7998 18.9655 38.57 18.8107Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_96_4212"
                    x1="28"
                    y1="47.5"
                    x2="31"
                    y2="-62"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#1066AF" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const LandingExperts: Icon = (props) => {
    return (
        <svg
            width="55"
            height="55"
            viewBox="0 0 55 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle
                cx="27.5"
                cy="27.5"
                r="27.5"
                fill="url(#paint0_linear_96_4219)"
            />
            <path
                d="M38.125 36.25C38.788 36.25 39.4239 35.9866 39.8928 35.5178C40.3616 35.0489 40.625 34.413 40.625 33.75V20C40.625 19.337 40.3616 18.7011 39.8928 18.2322C39.4239 17.7634 38.788 17.5 38.125 17.5H24.95C25.3875 18.2625 25.625 19.125 25.625 20H38.125V33.75H26.875V36.25M31.875 23.75V26.25H24.375V42.5H21.875V35H19.375V42.5H16.875V32.5H15V26.25C15 25.587 15.2634 24.9511 15.7322 24.4822C16.2011 24.0134 16.837 23.75 17.5 23.75H31.875ZM23.125 20C23.125 20.663 22.8616 21.2989 22.3928 21.7678C21.9239 22.2366 21.288 22.5 20.625 22.5C19.962 22.5 19.3261 22.2366 18.8572 21.7678C18.3884 21.2989 18.125 20.663 18.125 20C18.125 19.337 18.3884 18.7011 18.8572 18.2322C19.3261 17.7634 19.962 17.5 20.625 17.5C21.288 17.5 21.9239 17.7634 22.3928 18.2322C22.8616 18.7011 23.125 19.337 23.125 20Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_96_4219"
                    x1="31"
                    y1="55"
                    x2="31"
                    y2="-67"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#35B4A1" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const TwitterBird: Icon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            {...props}
        >
            <path d="M28,6.937c-0.957,0.425-1.985,0.711-3.064,0.84c1.102-0.66,1.947-1.705,2.345-2.951c-1.03,0.611-2.172,1.055-3.388,1.295 c-0.973-1.037-2.359-1.685-3.893-1.685c-2.946,0-5.334,2.389-5.334,5.334c0,0.418,0.048,0.826,0.138,1.215 c-4.433-0.222-8.363-2.346-10.995-5.574C3.351,6.199,3.088,7.115,3.088,8.094c0,1.85,0.941,3.483,2.372,4.439 c-0.874-0.028-1.697-0.268-2.416-0.667c0,0.023,0,0.044,0,0.067c0,2.585,1.838,4.741,4.279,5.23 c-0.447,0.122-0.919,0.187-1.406,0.187c-0.343,0-0.678-0.034-1.003-0.095c0.679,2.119,2.649,3.662,4.983,3.705 c-1.825,1.431-4.125,2.284-6.625,2.284c-0.43,0-0.855-0.025-1.273-0.075c2.361,1.513,5.164,2.396,8.177,2.396 c9.812,0,15.176-8.128,15.176-15.177c0-0.231-0.005-0.461-0.015-0.69C26.38,8.945,27.285,8.006,28,6.937z"></path>
        </svg>
    );
};

export const LinkedIn: Icon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="30"
            height="30"
            viewBox="0 0 510 510"
            className="fill-primary"
        >
            <g>
                <g id="post-linkedin">
                    <path
                        d="M459,0H51C22.95,0,0,22.95,0,51v408c0,28.05,22.95,51,51,51h408c28.05,0,51-22.95,51-51V51C510,22.95,487.05,0,459,0z
			 M153,433.5H76.5V204H153V433.5z M114.75,160.65c-25.5,0-45.9-20.4-45.9-45.9s20.4-45.9,45.9-45.9s45.9,20.4,45.9,45.9
			S140.25,160.65,114.75,160.65z M433.5,433.5H357V298.35c0-20.399-17.85-38.25-38.25-38.25s-38.25,17.851-38.25,38.25V433.5H204
			V204h76.5v30.6c12.75-20.4,40.8-35.7,63.75-35.7c48.45,0,89.25,40.8,89.25,89.25V433.5z"
                    />
                </g>
            </g>
        </svg>
    );
};

export const FilledLinkedIn: Icon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            {...props}
        >
            <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M10.954,22h-2.95 v-9.492h2.95V22z M9.449,11.151c-0.951,0-1.72-0.771-1.72-1.72c0-0.949,0.77-1.719,1.72-1.719c0.948,0,1.719,0.771,1.719,1.719 C11.168,10.38,10.397,11.151,9.449,11.151z M22.004,22h-2.948v-4.616c0-1.101-0.02-2.517-1.533-2.517 c-1.535,0-1.771,1.199-1.771,2.437V22h-2.948v-9.492h2.83v1.297h0.04c0.394-0.746,1.356-1.533,2.791-1.533 c2.987,0,3.539,1.966,3.539,4.522V22z"></path>
        </svg>
    );
};

export const DarkFacebook: Icon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            {...props}
        >
            <path d="M15,3C8.373,3,3,8.373,3,15c0,6.016,4.432,10.984,10.206,11.852V18.18h-2.969v-3.154h2.969v-2.099c0-3.475,1.693-5,4.581-5 c1.383,0,2.115,0.103,2.461,0.149v2.753h-1.97c-1.226,0-1.654,1.163-1.654,2.473v1.724h3.593L19.73,18.18h-3.106v8.697 C22.481,26.083,27,21.075,27,15C27,8.373,21.627,3,15,3z"></path>
        </svg>
    );
};

export const Facebook: Icon = (props) => {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clip-path="url(#clip0_155_2597)">
                <path
                    d="M22 11C22 4.92491 17.0751 0 11 0C4.92491 0 0 4.92491 0 11C0 16.4904 4.02256 21.0412 9.28125 21.8664V14.1797H6.48828V11H9.28125V8.57656C9.28125 5.81969 10.9235 4.29688 13.4362 4.29688C14.6396 4.29688 15.8984 4.51172 15.8984 4.51172V7.21875H14.5114C13.1449 7.21875 12.7188 8.0667 12.7188 8.93664V11H15.7695L15.2818 14.1797H12.7188V21.8664C17.9774 21.0412 22 16.4905 22 11Z"
                    fill="#1877F2"
                />
                <path
                    d="M15.2818 14.1797L15.7695 11H12.7188V8.93664C12.7188 8.06661 13.1449 7.21875 14.5114 7.21875H15.8984V4.51172C15.8984 4.51172 14.6396 4.29688 13.4361 4.29688C10.9235 4.29688 9.28125 5.81969 9.28125 8.57656V11H6.48828V14.1797H9.28125V21.8664C9.84983 21.9555 10.4245 22.0002 11 22C11.5755 22.0002 12.1502 21.9555 12.7188 21.8664V14.1797H15.2818Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_155_2597">
                    <rect width="22" height="22" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const GitHub: Icon = (props) => (
    <svg viewBox="0 0 438.549 438.549" {...props}>
        <path
            fill="currentColor"
            d="M409.132 114.573c-19.608-33.596-46.205-60.194-79.798-79.8-33.598-19.607-70.277-29.408-110.063-29.408-39.781 0-76.472 9.804-110.063 29.408-33.596 19.605-60.192 46.204-79.8 79.8C9.803 148.168 0 184.854 0 224.63c0 47.78 13.94 90.745 41.827 128.906 27.884 38.164 63.906 64.572 108.063 79.227 5.14.954 8.945.283 11.419-1.996 2.475-2.282 3.711-5.14 3.711-8.562 0-.571-.049-5.708-.144-15.417a2549.81 2549.81 0 01-.144-25.406l-6.567 1.136c-4.187.767-9.469 1.092-15.846 1-6.374-.089-12.991-.757-19.842-1.999-6.854-1.231-13.229-4.086-19.13-8.559-5.898-4.473-10.085-10.328-12.56-17.556l-2.855-6.57c-1.903-4.374-4.899-9.233-8.992-14.559-4.093-5.331-8.232-8.945-12.419-10.848l-1.999-1.431c-1.332-.951-2.568-2.098-3.711-3.429-1.142-1.331-1.997-2.663-2.568-3.997-.572-1.335-.098-2.43 1.427-3.289 1.525-.859 4.281-1.276 8.28-1.276l5.708.853c3.807.763 8.516 3.042 14.133 6.851 5.614 3.806 10.229 8.754 13.846 14.842 4.38 7.806 9.657 13.754 15.846 17.847 6.184 4.093 12.419 6.136 18.699 6.136 6.28 0 11.704-.476 16.274-1.423 4.565-.952 8.848-2.383 12.847-4.285 1.713-12.758 6.377-22.559 13.988-29.41-10.848-1.14-20.601-2.857-29.264-5.14-8.658-2.286-17.605-5.996-26.835-11.14-9.235-5.137-16.896-11.516-22.985-19.126-6.09-7.614-11.088-17.61-14.987-29.979-3.901-12.374-5.852-26.648-5.852-42.826 0-23.035 7.52-42.637 22.557-58.817-7.044-17.318-6.379-36.732 1.997-58.24 5.52-1.715 13.706-.428 24.554 3.853 10.85 4.283 18.794 7.952 23.84 10.994 5.046 3.041 9.089 5.618 12.135 7.708 17.705-4.947 35.976-7.421 54.818-7.421s37.117 2.474 54.823 7.421l10.849-6.849c7.419-4.57 16.18-8.758 26.262-12.565 10.088-3.805 17.802-4.853 23.134-3.138 8.562 21.509 9.325 40.922 2.279 58.24 15.036 16.18 22.559 35.787 22.559 58.817 0 16.178-1.958 30.497-5.853 42.966-3.9 12.471-8.941 22.457-15.125 29.979-6.191 7.521-13.901 13.85-23.131 18.986-9.232 5.14-18.182 8.85-26.84 11.136-8.662 2.286-18.415 4.004-29.263 5.146 9.894 8.562 14.842 22.077 14.842 40.539v60.237c0 3.422 1.19 6.279 3.572 8.562 2.379 2.279 6.136 2.95 11.276 1.995 44.163-14.653 80.185-41.062 108.068-79.226 27.88-38.161 41.825-81.126 41.825-128.906-.01-39.771-9.818-76.454-29.414-110.049z"
        ></path>
    </svg>
);

export const React: Icon = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            d="M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z"
        />
    </svg>
);

export const Nextjs: Icon = (props) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fill="currentColor"
            d="M11.5725 0c-.1763 0-.3098.0013-.3584.0067-.0516.0053-.2159.021-.3636.0328-3.4088.3073-6.6017 2.1463-8.624 4.9728C1.1004 6.584.3802 8.3666.1082 10.255c-.0962.659-.108.8537-.108 1.7474s.012 1.0884.108 1.7476c.652 4.506 3.8591 8.2919 8.2087 9.6945.7789.2511 1.6.4223 2.5337.5255.3636.04 1.9354.04 2.299 0 1.6117-.1783 2.9772-.577 4.3237-1.2643.2065-.1056.2464-.1337.2183-.1573-.0188-.0139-.8987-1.1938-1.9543-2.62l-1.919-2.592-2.4047-3.5583c-1.3231-1.9564-2.4117-3.556-2.4211-3.556-.0094-.0026-.0187 1.5787-.0235 3.509-.0067 3.3802-.0093 3.5162-.0516 3.596-.061.115-.108.1618-.2064.2134-.075.0374-.1408.0445-.495.0445h-.406l-.1078-.068a.4383.4383 0 01-.1572-.1712l-.0493-.1056.0053-4.703.0067-4.7054.0726-.0915c.0376-.0493.1174-.1125.1736-.143.0962-.047.1338-.0517.5396-.0517.4787 0 .5584.0187.6827.1547.0353.0377 1.3373 1.9987 2.895 4.3608a10760.433 10760.433 0 004.7344 7.1706l1.9002 2.8782.096-.0633c.8518-.5536 1.7525-1.3418 2.4657-2.1627 1.5179-1.7429 2.4963-3.868 2.8247-6.134.0961-.6591.1078-.854.1078-1.7475 0-.8937-.012-1.0884-.1078-1.7476-.6522-4.506-3.8592-8.2919-8.2087-9.6945-.7672-.2487-1.5836-.42-2.4985-.5232-.169-.0176-1.0835-.0366-1.6123-.037zm4.0685 7.217c.3473 0 .4082.0053.4857.047.1127.0562.204.1642.237.2767.0186.061.0234 1.3653.0186 4.3044l-.0067 4.2175-.7436-1.14-.7461-1.14v-3.066c0-1.982.0093-3.0963.0234-3.1502.0375-.1313.1196-.2346.2323-.2955.0961-.0494.1313-.054.4997-.054z"
        />
    </svg>
);

export const Prisma: Icon = (props) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fill="currentColor"
            d="M21.8068 18.2848L13.5528.7565c-.207-.4382-.639-.7273-1.1286-.7541-.5023-.0293-.9523.213-1.2062.6253L2.266 15.1271c-.2773.4518-.2718 1.0091.0158 1.4555l4.3759 6.7786c.2608.4046.7127.6388 1.1823.6388.1332 0 .267-.0188.3987-.0577l12.7019-3.7568c.3891-.1151.7072-.3904.8737-.7553s.1633-.7828-.0075-1.1454zm-1.8481.7519L9.1814 22.2242c-.3292.0975-.6448-.1873-.5756-.5194l3.8501-18.4386c.072-.3448.5486-.3996.699-.0803l7.1288 15.138c.1344.2856-.019.6224-.325.7128z"
        />
    </svg>
);

export const Kysely: Icon = (props) => (
    <svg
        width="132"
        height="132"
        viewBox="0 0 132 132"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_8_3)">
            <rect x="2" y="2" width="128" height="128" rx="16" fill="white" />
            <path
                d="M41.2983 109V23.9091H46.4918V73.31H47.0735L91.9457 23.9091H98.8427L61.9062 64.1694L98.5103 109H92.0288L58.5824 67.9087L46.4918 81.2873V109H41.2983Z"
                fill="black"
            />
        </g>
        <rect
            x="2"
            y="2"
            width="128"
            height="128"
            rx="16"
            stroke="#121212"
            strokeWidth="4"
        />
        <defs>
            <clipPath id="clip0_8_3">
                <rect
                    x="2"
                    y="2"
                    width="128"
                    height="128"
                    rx="16"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);

export const Tailwind: Icon = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M12.001,4.8c-3.2,0-5.2,1.6-6,4.8c1.2-1.6,2.6-2.2,4.2-1.8c0.913,0.228,1.565,0.89,2.288,1.624 C13.666,10.618,15.027,12,18.001,12c3.2,0,5.2-1.6,6-4.8c-1.2,1.6-2.6,2.2-4.2,1.8c-0.913-0.228-1.565-0.89-2.288-1.624 C16.337,6.182,14.976,4.8,12.001,4.8z M6.001,12c-3.2,0-5.2,1.6-6,4.8c1.2-1.6,2.6-2.2,4.2-1.8c0.913,0.228,1.565,0.89,2.288,1.624 c1.177,1.194,2.538,2.576,5.512,2.576c3.2,0,5.2-1.6,6-4.8c-1.2,1.6-2.6,2.2-4.2,1.8c-0.913-0.228-1.565-0.89-2.288-1.624 C10.337,13.382,8.976,12,6.001,12z" />
    </svg>
);

export const Google: Icon = (props) => (
    <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M20.8973 9.62319H20.1253V9.58341H11.5003V13.4167H16.9163C16.1262 15.6482 14.003 17.2501 11.5003 17.2501C8.32489 17.2501 5.75033 14.6755 5.75033 11.5001C5.75033 8.32464 8.32489 5.75008 11.5003 5.75008C12.9661 5.75008 14.2996 6.30304 15.315 7.20627L18.0256 4.49562C16.314 2.90048 14.0246 1.91675 11.5003 1.91675C6.20793 1.91675 1.91699 6.20769 1.91699 11.5001C1.91699 16.7925 6.20793 21.0834 11.5003 21.0834C16.7927 21.0834 21.0837 16.7925 21.0837 11.5001C21.0837 10.8575 21.0175 10.2303 20.8973 9.62319Z"
            fill="#FFC107"
        />
        <path
            d="M3.02148 7.03952L6.17009 9.34862C7.02205 7.23933 9.08534 5.75008 11.4999 5.75008C12.9656 5.75008 14.2992 6.30304 15.3145 7.20627L18.0252 4.49562C16.3136 2.90048 14.0241 1.91675 11.4999 1.91675C7.8189 1.91675 4.62669 3.99489 3.02148 7.03952Z"
            fill="#FF3D00"
        />
        <path
            d="M11.5003 21.0834C13.9757 21.0834 16.2249 20.1361 17.9255 18.5956L14.9594 16.0857C13.9649 16.842 12.7497 17.2511 11.5003 17.2501C9.00769 17.2501 6.89121 15.6607 6.09388 13.4426L2.96875 15.8504C4.55479 18.954 7.77575 21.0834 11.5003 21.0834Z"
            fill="#4CAF50"
        />
        <path
            d="M20.8969 9.62302H20.125V9.58325H11.5V13.4166H16.916C16.5381 14.4786 15.8572 15.4066 14.9577 16.086L14.9591 16.0851L17.9251 18.5949C17.7153 18.7856 21.0833 16.2916 21.0833 11.4999C21.0833 10.8574 21.0172 10.2301 20.8969 9.62302Z"
            fill="#1976D2"
        />
    </svg>
);

export const Twitter: Icon = (props) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 1227 1227"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            className="fill-primary"
        >
            <path d="m654.53 592.55 276.12 394.95h-113.32l-225.32-322.28v-.02l-33.08-47.31-263.21-376.5h113.32l212.41 303.85z" />
            <path d="m1094.42 0h-961.84c-73.22 0-132.58 59.36-132.58 132.58v961.84c0 73.22 59.36 132.58 132.58 132.58h961.84c73.22 0 132.58-59.36 132.58-132.58v-961.84c0-73.22-59.36-132.58-132.58-132.58zm-311.8 1040.52-228.01-331.84-285.47 331.84h-73.78l326.49-379.5-326.49-475.17h249.02l215.91 314.23 270.32-314.23h73.78l-311.33 361.9h-.02l338.6 492.77z" />
        </svg>
    );
};

export const Youtube: Icon = (props) => {
    return (
        <svg
            width="32"
            height="32"
            role="img"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="fill-primary"
        >
            <title>YouTube</title>
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
    );
};

export const Instagram: Icon = (props) => {
    return (
        <svg
            viewBox="0 0 512 512"
            width="32"
            height="32"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            className="fill-primary"
        >
            <path d="m301 256c0 24.851562-20.148438 45-45 45s-45-20.148438-45-45 20.148438-45 45-45 45 20.148438 45 45zm0 0" />
            <path d="m332 120h-152c-33.085938 0-60 26.914062-60 60v152c0 33.085938 26.914062 60 60 60h152c33.085938 0 60-26.914062 60-60v-152c0-33.085938-26.914062-60-60-60zm-76 211c-41.355469 0-75-33.644531-75-75s33.644531-75 75-75 75 33.644531 75 75-33.644531 75-75 75zm86-146c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15 15 6.714844 15 15-6.714844 15-15 15zm0 0" />
            <path d="m377 0h-242c-74.4375 0-135 60.5625-135 135v242c0 74.4375 60.5625 135 135 135h242c74.4375 0 135-60.5625 135-135v-242c0-74.4375-60.5625-135-135-135zm45 332c0 49.625-40.375 90-90 90h-152c-49.625 0-90-40.375-90-90v-152c0-49.625 40.375-90 90-90h152c49.625 0 90 40.375 90 90zm0 0" />
        </svg>
    );
};

export const Tiktok: Icon = (props) => {
    return (
        <svg
            {...props}
            width="23"
            height="23"
            role="img"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>TikTok</title>
            <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
        </svg>
    );
};
export const Gender: Icon = (props) => {
    return (
        <svg
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M19.4068 2.51562H15.0943C14.8083 2.51562 14.5341 2.62921 14.3319 2.8314C14.1297 3.03359 14.0161 3.30781 14.0161 3.59375C14.0161 3.87969 14.1297 4.15391 14.3319 4.3561C14.5341 4.55829 14.8083 4.67188 15.0943 4.67188H16.8013L13.8616 7.61336C12.3334 6.47125 10.4293 5.95033 8.53254 6.1554C6.63575 6.36048 4.88703 7.27633 3.63823 8.71868C2.38944 10.161 1.73327 12.0228 1.80174 13.9294C1.87022 15.836 2.65826 17.646 4.00731 18.995C5.35635 20.344 7.16628 21.1321 9.07288 21.2006C10.9795 21.269 12.8413 20.6129 14.2836 19.3641C15.726 18.1153 16.6418 16.3666 16.8469 14.4698C17.052 12.573 16.5311 10.6689 15.3889 9.1407L18.3286 6.19922V7.90625C18.3286 8.19219 18.4422 8.46641 18.6444 8.6686C18.8466 8.87079 19.1208 8.98438 19.4068 8.98438C19.6927 8.98438 19.9669 8.87079 20.1691 8.6686C20.3713 8.46641 20.4849 8.19219 20.4849 7.90625V3.59375C20.4849 3.30781 20.3713 3.03359 20.1691 2.8314C19.9669 2.62921 19.6927 2.51562 19.4068 2.51562ZM13.1545 17.471C12.4006 18.2247 11.44 18.7379 10.3944 18.9457C9.34879 19.1535 8.26503 19.0466 7.28015 18.6386C6.29527 18.2305 5.4535 17.5396 4.86127 16.6531C4.26903 15.7667 3.95293 14.7246 3.95293 13.6585C3.95293 12.5924 4.26903 11.5503 4.86127 10.6639C5.4535 9.77742 6.29527 9.08648 7.28015 8.67842C8.26503 8.27035 9.34879 8.16347 10.3944 8.37129C11.44 8.57911 12.4006 9.0923 13.1545 9.84598C14.1637 10.8581 14.7305 12.2292 14.7305 13.6585C14.7305 15.0878 14.1637 16.4588 13.1545 17.471Z"
                fill="#9CA7B9"
            />
        </svg>
    );
};

export const Excel: Icon = (props) => {
    return (
        <svg
            width="200"
            height="240"
            viewBox="0 0 200 240"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.3">
                <path
                    opacity="0.3"
                    d="M139.67 49.25C134.203 49.2447 128.961 47.0704 125.095 43.2046C121.229 39.3387 119.055 34.097 119.05 28.6299V0H26.91C19.773 0 12.9284 2.83523 7.88176 7.88184C2.83516 12.9284 0 19.7729 0 26.9099V189.13C0.0105984 196.26 2.85043 203.094 7.89589 208.132C12.9413 213.17 19.78 216 26.91 216H137.51C141.045 216.001 144.545 215.306 147.811 213.955C151.077 212.603 154.045 210.621 156.545 208.122C159.045 205.623 161.028 202.656 162.381 199.39C163.734 196.125 164.43 192.625 164.43 189.09V49.21L139.67 49.25Z"
                    fill="#00C650"
                />
            </g>
            <path
                d="M164.43 49.25H139.67C134.203 49.2447 128.961 47.0704 125.095 43.2046C121.229 39.3387 119.055 34.097 119.05 28.6299V0L164.43 49.25Z"
                fill="#00C650"
            />
            <path
                d="M183.94 170.61H58.9C50.0303 170.61 42.84 177.8 42.84 186.67V223.95C42.84 232.82 50.0303 240.01 58.9 240.01H183.94C192.81 240.01 200 232.82 200 223.95V186.67C200 177.8 192.81 170.61 183.94 170.61Z"
                fill="#00C650"
            />
            <path d="M80.49 213.12V220.37H73V213.12H80.49Z" fill="white" />
            <path
                d="M107.4 193.14C109.931 195.188 111.65 198.07 112.25 201.27H104.59C104.079 199.942 103.176 198.802 102 198C100.763 197.189 99.3086 196.774 97.83 196.81C96.8551 196.781 95.8865 196.975 94.9989 197.379C94.1112 197.783 93.3281 198.386 92.71 199.14C91.3358 200.917 90.644 203.127 90.76 205.37C90.6432 207.604 91.3355 209.805 92.71 211.57C93.3306 212.32 94.1146 212.919 95.0021 213.319C95.8896 213.719 96.8569 213.911 97.83 213.88C99.3086 213.916 100.763 213.501 102 212.69C103.175 211.905 104.085 210.782 104.61 209.47H112.27C111.657 212.66 109.94 215.531 107.42 217.58C104.716 219.659 101.368 220.721 97.96 220.58C95.2762 220.639 92.6263 219.972 90.29 218.65C88.101 217.384 86.3286 215.508 85.19 213.25C83.9574 210.798 83.3397 208.084 83.39 205.34C83.3385 202.593 83.9562 199.875 85.19 197.42C86.3286 195.162 88.101 193.286 90.29 192.02C92.6263 190.698 95.2762 190.031 97.96 190.09C101.366 189.973 104.706 191.052 107.4 193.14Z"
                fill="white"
            />
            <path
                d="M136.63 216.3C135.768 217.675 134.534 218.778 133.07 219.48C131.289 220.314 129.336 220.718 127.37 220.66C124.409 220.78 121.491 219.919 119.07 218.21C118.001 217.406 117.126 216.372 116.509 215.185C115.893 213.998 115.552 212.687 115.51 211.35H123.22C123.273 212.358 123.706 213.308 124.43 214.01C125.146 214.681 126.099 215.04 127.08 215.01C127.884 215.051 128.673 214.778 129.28 214.25C129.543 213.989 129.75 213.677 129.888 213.333C130.026 212.989 130.091 212.62 130.08 212.25C130.089 211.9 130.029 211.552 129.902 211.225C129.775 210.899 129.584 210.602 129.34 210.35C128.815 209.817 128.189 209.392 127.5 209.1C126.76 208.77 125.75 208.38 124.45 207.93C122.863 207.408 121.313 206.78 119.81 206.05C118.575 205.411 117.514 204.481 116.72 203.34C115.806 201.955 115.355 200.317 115.43 198.66C115.389 197.017 115.861 195.402 116.78 194.04C117.725 192.709 119.024 191.67 120.53 191.04C122.272 190.335 124.141 189.995 126.02 190.04C128.861 189.89 131.666 190.727 133.96 192.41C134.939 193.204 135.741 194.194 136.312 195.317C136.884 196.44 137.214 197.671 137.28 198.93H129.45C129.354 198.05 128.975 197.226 128.37 196.58C128.057 196.284 127.688 196.054 127.284 195.904C126.88 195.755 126.45 195.689 126.02 195.71C125.273 195.672 124.538 195.914 123.96 196.39C123.69 196.644 123.479 196.956 123.344 197.302C123.209 197.648 123.153 198.019 123.18 198.39C123.171 198.721 123.229 199.051 123.349 199.36C123.469 199.669 123.65 199.951 123.88 200.19C124.376 200.712 124.975 201.124 125.64 201.4C126.34 201.71 127.36 202.11 128.64 202.59C130.256 203.11 131.831 203.752 133.35 204.51C134.596 205.18 135.668 206.132 136.48 207.29C137.407 208.692 137.866 210.351 137.79 212.03C137.797 213.532 137.396 215.008 136.63 216.3Z"
                fill="white"
            />
            <path
                d="M147.44 190.43L154.77 212.96L162.1 190.43H169.85L159.43 220.37H150.07L139.69 190.43H147.44Z"
                fill="white"
            />
            <path
                d="M118.89 150.8H45.54C39.19 150.8 34.03 144.48 34.03 136.7V83.51C34.03 75.74 39.19 69.4199 45.54 69.4199H118.89C125.24 69.4199 130.4 75.74 130.4 83.51V136.7C130.4 144.48 125.24 150.8 118.89 150.8ZM45.54 76.6201C42.44 76.6201 39.91 79.71 39.91 83.51V136.7C39.91 140.5 42.44 143.59 45.54 143.59H118.89C121.99 143.59 124.51 140.5 124.51 136.7V83.51C124.51 79.71 121.99 76.6201 118.89 76.6201H45.54Z"
                fill="#00C650"
            />
            <path
                d="M127.46 118.77H36.97V125.98H127.46V118.77Z"
                fill="#00C650"
            />
            <path d="M127.46 94.05H36.97V101.26H127.46V94.05Z" fill="#00C650" />
            <path d="M104.29 73.02H97.08V147.19H104.29V73.02Z" fill="#00C650" />
            <path d="M67.35 73.02H60.14V147.19H67.35V73.02Z" fill="#00C650" />
        </svg>
    );
};

export const Pdf: Icon = (props) => {
    return (
        <svg
            width="201"
            height="240"
            viewBox="0 0 201 240"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.3">
                <path
                    opacity="0.3"
                    d="M140.24 49.25C134.773 49.2447 129.531 47.0704 125.665 43.2046C121.799 39.3387 119.625 34.097 119.62 28.6299V0H27.48C20.343 0 13.4984 2.83523 8.45178 7.88184C3.40518 12.9284 0.570007 19.7729 0.570007 26.9099V189.13C0.580606 196.26 3.42043 203.094 8.46588 208.132C13.5113 213.17 20.3499 216 27.48 216H138.09C145.22 216 152.059 213.17 157.104 208.132C162.15 203.094 164.989 196.26 165 189.13V49.25H140.24Z"
                    fill="#FF3E4C"
                />
            </g>
            <path
                d="M165 49.25H140.24C134.773 49.2447 129.531 47.0704 125.665 43.2046C121.799 39.3387 119.625 34.097 119.62 28.6299V0L165 49.25Z"
                fill="#FF3E4C"
            />
            <path
                d="M131.17 150.84H27.93C26.9354 150.84 25.9816 150.445 25.2783 149.742C24.5751 149.038 24.18 148.085 24.18 147.09C24.1826 146.097 24.5789 145.146 25.2819 144.445C25.9848 143.744 26.9372 143.35 27.93 143.35H131.17C132.162 143.35 133.113 143.744 133.815 144.445C134.516 145.147 134.91 146.098 134.91 147.09C134.911 147.582 134.816 148.07 134.628 148.524C134.441 148.979 134.166 149.393 133.818 149.741C133.471 150.089 133.058 150.366 132.604 150.554C132.149 150.743 131.662 150.84 131.17 150.84Z"
                fill="#FF3E4C"
            />
            <path
                d="M131.17 108.6H27.93C26.9372 108.6 25.9848 108.206 25.2819 107.505C24.5789 106.804 24.1826 105.853 24.18 104.86C24.18 103.866 24.5751 102.912 25.2783 102.208C25.9816 101.505 26.9354 101.11 27.93 101.11H131.17C131.662 101.11 132.149 101.207 132.604 101.396C133.058 101.584 133.471 101.861 133.818 102.209C134.166 102.557 134.441 102.971 134.628 103.426C134.816 103.881 134.911 104.368 134.91 104.86C134.91 105.852 134.516 106.803 133.815 107.505C133.113 108.206 132.162 108.6 131.17 108.6Z"
                fill="#FF3E4C"
            />
            <path
                d="M131.17 129.72H27.93C26.9354 129.72 25.9816 129.325 25.2783 128.622C24.5751 127.918 24.18 126.965 24.18 125.97C24.1826 124.977 24.5789 124.026 25.2819 123.325C25.9848 122.624 26.9372 122.23 27.93 122.23H131.17C132.162 122.23 133.113 122.624 133.815 123.325C134.516 124.027 134.91 124.978 134.91 125.97C134.911 126.462 134.816 126.949 134.628 127.404C134.441 127.859 134.166 128.273 133.818 128.621C133.471 128.969 133.058 129.246 132.604 129.434C132.149 129.623 131.662 129.72 131.17 129.72Z"
                fill="#FF3E4C"
            />
            <path
                d="M90.45 87.48H27.93C26.9372 87.48 25.9848 87.0864 25.2819 86.3853C24.5789 85.6842 24.1826 84.7328 24.18 83.74C24.18 82.7454 24.5751 81.7916 25.2783 81.0884C25.9816 80.3851 26.9354 79.99 27.93 79.99H90.45C91.4428 79.9926 92.3941 80.3888 93.0952 81.0918C93.7963 81.7948 94.19 82.7472 94.19 83.74C94.1874 84.7311 93.7925 85.6808 93.0917 86.3816C92.3909 87.0824 91.4411 87.4773 90.45 87.48Z"
                fill="#FF3E4C"
            />
            <path
                d="M90.45 66.3601H27.93C26.9372 66.3601 25.9848 65.9662 25.2819 65.2651C24.5789 64.564 24.1826 63.6129 24.18 62.6201C24.18 61.6256 24.5751 60.6715 25.2783 59.9683C25.9816 59.265 26.9354 58.8701 27.93 58.8701H90.45C91.4428 58.8728 92.3941 59.2689 93.0952 59.9719C93.7963 60.6749 94.19 61.6273 94.19 62.6201C94.1874 63.6112 93.7925 64.5609 93.0917 65.2617C92.3909 65.9625 91.4411 66.3575 90.45 66.3601Z"
                fill="#FF3E4C"
            />
            <path
                d="M184.51 170.61H59.47C50.6003 170.61 43.41 177.8 43.41 186.67V223.95C43.41 232.82 50.6003 240.01 59.47 240.01H184.51C193.38 240.01 200.57 232.82 200.57 223.95V186.67C200.57 177.8 193.38 170.61 184.51 170.61Z"
                fill="#FF3E4C"
            />
            <path d="M84.43 213.38V220.65H76.91V213.38H84.43Z" fill="white" />
            <path
                d="M95.49 210.1V220.65H88.22V190.58H100C103.57 190.58 106.3 191.47 108.17 193.24C109.116 194.17 109.855 195.289 110.338 196.525C110.82 197.761 111.036 199.085 110.97 200.41C111.006 202.158 110.575 203.884 109.72 205.41C108.847 206.901 107.553 208.102 106 208.86C104.127 209.745 102.071 210.174 100 210.11L95.49 210.1ZM103.57 200.41C103.57 197.743 102.11 196.41 99.19 196.41H95.49V204.24H99.19C102.11 204.267 103.57 202.99 103.57 200.41Z"
                fill="white"
            />
            <path
                d="M139.7 213.4C138.448 215.674 136.557 217.53 134.26 218.74C131.676 220.063 128.802 220.719 125.9 220.65H114.55V190.58H125.9C128.804 190.507 131.682 191.149 134.28 192.45C136.57 193.634 138.457 195.471 139.7 197.73C141.001 200.128 141.656 202.823 141.6 205.55C141.654 208.287 141 210.991 139.7 213.4ZM131.88 211.89C132.693 211.056 133.323 210.061 133.729 208.969C134.135 207.877 134.309 206.713 134.24 205.55C134.31 204.389 134.136 203.225 133.73 202.135C133.323 201.045 132.693 200.052 131.88 199.22C130.061 197.624 127.685 196.812 125.27 196.96H121.82V214.14H125.27C127.683 214.287 130.057 213.478 131.88 211.89Z"
                fill="white"
            />
            <path
                d="M165.33 190.58V196.37H153V202.96H162.52V208.49H153V220.65H145.72V190.58H165.33Z"
                fill="white"
            />
            <path
                d="M129.34 58.87H111.66C108.578 58.87 106.08 61.3682 106.08 64.45V82.13C106.08 85.2117 108.578 87.71 111.66 87.71H129.34C132.422 87.71 134.92 85.2117 134.92 82.13V64.45C134.92 61.3682 132.422 58.87 129.34 58.87Z"
                fill="#FF3E4C"
            />
        </svg>
    );
};

export const Word: Icon = (props) => {
    return (
        <svg
            width="201"
            height="240"
            viewBox="0 0 201 240"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.3">
                <path
                    opacity="0.3"
                    d="M140.38 49.25C134.913 49.2447 129.671 47.0704 125.805 43.2046C121.939 39.3387 119.765 34.097 119.76 28.6299V1.85854e-06H27.63C24.0953 -0.00131167 20.5949 0.693646 17.3289 2.04541C14.0628 3.39718 11.0952 5.37922 8.59534 7.87818C6.09545 10.3771 4.11238 13.3441 2.7594 16.6096C1.40642 19.8751 0.709961 23.3752 0.709961 26.9099V189.13C0.709961 192.665 1.40642 196.165 2.7594 199.43C4.11238 202.696 6.09545 205.663 8.59534 208.162C11.0952 210.661 14.0628 212.643 17.3289 213.994C20.5949 215.346 24.0953 216.041 27.63 216.04H138.23C141.764 216.04 145.263 215.344 148.528 213.992C151.793 212.639 154.759 210.657 157.258 208.158C159.757 205.659 161.739 202.693 163.092 199.428C164.444 196.163 165.14 192.664 165.14 189.13V49.25H140.38Z"
                    fill="#0072FF"
                />
            </g>
            <path
                d="M165.14 49.25H140.38C134.913 49.2447 129.671 47.0704 125.805 43.2046C121.939 39.3387 119.765 34.097 119.76 28.6299V0L165.14 49.25Z"
                fill="#0072FF"
            />
            <path
                d="M131.31 83.73H28.07C27.078 83.73 26.1268 83.3359 25.4254 82.6345C24.724 81.9331 24.33 80.9819 24.33 79.99C24.3287 79.498 24.4245 79.0106 24.6118 78.5557C24.7992 78.1008 25.0745 77.6872 25.4219 77.3389C25.7693 76.9905 26.1821 76.7142 26.6365 76.5256C27.0909 76.3371 27.578 76.24 28.07 76.24H131.31C132.305 76.24 133.258 76.6351 133.962 77.3384C134.665 78.0416 135.06 78.9954 135.06 79.99C135.057 80.9828 134.661 81.9342 133.958 82.6353C133.255 83.3364 132.303 83.73 131.31 83.73Z"
                fill="#0072FF"
            />
            <path
                d="M131.31 106.1H28.07C27.078 106.1 26.1268 105.706 25.4254 105.005C24.724 104.303 24.33 103.352 24.33 102.36C24.3287 101.868 24.4245 101.381 24.6118 100.926C24.7992 100.471 25.0745 100.057 25.4219 99.709C25.7693 99.3606 26.1821 99.0843 26.6365 98.8958C27.0909 98.7072 27.578 98.6101 28.07 98.6101H131.31C132.305 98.6101 133.258 99.005 133.962 99.7083C134.665 100.412 135.06 101.366 135.06 102.36C135.057 103.353 134.661 104.304 133.958 105.005C133.255 105.706 132.303 106.1 131.31 106.1Z"
                fill="#0072FF"
            />
            <path
                d="M131.31 128.47H28.07C27.578 128.47 27.0909 128.373 26.6365 128.184C26.1821 127.996 25.7693 127.719 25.4219 127.371C25.0745 127.023 24.7992 126.609 24.6118 126.154C24.4245 125.699 24.3287 125.212 24.33 124.72C24.33 123.728 24.724 122.777 25.4254 122.075C26.1268 121.374 27.078 120.98 28.07 120.98H131.31C132.303 120.98 133.255 121.374 133.958 122.075C134.661 122.776 135.057 123.727 135.06 124.72C135.06 125.715 134.665 126.668 133.962 127.372C133.258 128.075 132.305 128.47 131.31 128.47Z"
                fill="#0072FF"
            />
            <path
                d="M90.59 150.84H28.07C27.578 150.84 27.0909 150.743 26.6365 150.554C26.1821 150.366 25.7693 150.089 25.4219 149.741C25.0745 149.393 24.7992 148.979 24.6118 148.524C24.4245 148.07 24.3287 147.582 24.33 147.09C24.33 146.098 24.724 145.147 25.4254 144.445C26.1268 143.744 27.078 143.35 28.07 143.35H90.59C91.5819 143.35 92.5332 143.744 93.2346 144.445C93.936 145.147 94.33 146.098 94.33 147.09C94.3313 147.582 94.2356 148.07 94.0482 148.524C93.8609 148.979 93.5856 149.393 93.2382 149.741C92.8908 150.089 92.478 150.366 92.0236 150.554C91.5692 150.743 91.082 150.84 90.59 150.84Z"
                fill="#0072FF"
            />
            <path
                d="M184.66 170.61H59.62C50.7503 170.61 43.5601 177.8 43.5601 186.67V223.95C43.5601 232.82 50.7503 240.01 59.62 240.01H184.66C193.53 240.01 200.72 232.82 200.72 223.95V186.67C200.72 177.8 193.53 170.61 184.66 170.61Z"
                fill="#0072FF"
            />
            <path
                d="M76.9301 213.38V220.65H69.4V213.38H76.9301Z"
                fill="white"
            />
            <path
                d="M105.87 213.4C104.618 215.674 102.727 217.53 100.43 218.74C97.8455 220.062 94.9721 220.718 92.0699 220.65H80.71V190.58H92.0699C94.9742 190.508 97.8517 191.15 100.45 192.45C102.737 193.638 104.623 195.474 105.87 197.73C107.163 200.13 107.814 202.824 107.76 205.55C107.811 208.285 107.161 210.988 105.87 213.4ZM98.05 211.89C98.863 211.056 99.4927 210.061 99.899 208.969C100.305 207.877 100.48 206.713 100.41 205.55C100.48 204.389 100.306 203.225 99.8997 202.135C99.4932 201.045 98.8632 200.052 98.05 199.22C96.2281 197.623 93.8485 196.81 91.4301 196.96H88V214.14H91.4399C93.853 214.286 96.2269 213.478 98.05 211.89Z"
                fill="white"
            />
            <path
                d="M133.9 192.09C136.188 193.389 138.079 195.287 139.37 197.58C140.723 200.001 141.413 202.737 141.37 205.51C141.416 208.29 140.726 211.033 139.37 213.46C138.075 215.761 136.177 217.666 133.88 218.97C131.542 220.305 128.892 220.995 126.2 220.97C123.508 220.994 120.858 220.304 118.52 218.97C116.224 217.669 114.329 215.763 113.04 213.46C111.68 211.034 110.989 208.29 111.04 205.51C110.988 202.736 111.679 199.998 113.04 197.58C114.335 195.287 116.229 193.389 118.52 192.09C120.858 190.756 123.508 190.066 126.2 190.09C128.898 190.065 131.555 190.755 133.9 192.09ZM120.5 199.19C119.025 200.955 118.274 203.213 118.4 205.51C118.274 207.797 119.025 210.047 120.5 211.8C121.219 212.581 122.099 213.195 123.081 213.599C124.062 214.004 125.12 214.188 126.18 214.14C127.237 214.185 128.291 213.999 129.268 213.595C130.246 213.191 131.124 212.578 131.84 211.8C133.322 210.05 134.081 207.8 133.96 205.51C134.08 203.223 133.33 200.976 131.86 199.22C131.142 198.438 130.261 197.824 129.28 197.42C128.298 197.015 127.24 196.831 126.18 196.88C125.123 196.831 124.067 197.013 123.086 197.412C122.106 197.81 121.223 198.417 120.5 199.19Z"
                fill="white"
            />
            <path
                d="M168.69 193.3C171.226 195.364 172.951 198.257 173.56 201.47H165.86C165.34 200.139 164.431 198.995 163.25 198.19C162.005 197.38 160.545 196.965 159.06 197C158.08 196.969 157.105 197.163 156.212 197.569C155.319 197.975 154.531 198.581 153.91 199.34C152.517 201.121 151.808 203.342 151.91 205.6C151.808 207.849 152.518 210.06 153.91 211.83C154.536 212.581 155.326 213.18 156.218 213.58C157.11 213.981 158.082 214.172 159.06 214.14C160.545 214.18 162.007 213.764 163.25 212.95C164.424 212.159 165.333 211.034 165.86 209.72H173.56C172.941 212.923 171.218 215.808 168.69 217.87C165.97 219.947 162.609 221.008 159.19 220.87C156.496 220.927 153.836 220.257 151.49 218.93C149.295 217.654 147.514 215.772 146.36 213.51C145.12 211.029 144.503 208.283 144.56 205.51C144.504 202.737 145.121 199.992 146.36 197.51C147.514 195.248 149.295 193.366 151.49 192.09C153.836 190.763 156.496 190.093 159.19 190.15C162.627 190.059 165.988 191.173 168.69 193.3Z"
                fill="white"
            />
        </svg>
    );
};

export const Image: Icon = (props) => {
    return (
        <svg
            width="201"
            height="240"
            viewBox="0 0 201 240"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.3">
                <path
                    opacity="0.3"
                    d="M140.1 49.24C134.632 49.2373 129.389 47.0641 125.522 43.1976C121.656 39.3312 119.483 34.0879 119.48 28.62V0H27.3401C23.8054 -2.4406e-07 20.3053 0.696337 17.0398 2.04932C13.7743 3.4023 10.8071 5.38537 8.30811 7.88525C5.80915 10.3851 3.82735 13.3529 2.47559 16.6189C1.12382 19.8849 0.42862 23.3853 0.429933 26.92V189.13C0.42862 192.665 1.12382 196.165 2.47559 199.431C3.82735 202.697 5.80915 205.665 8.30811 208.165C10.8071 210.665 13.7743 212.648 17.0398 214.001C20.3053 215.354 23.8054 216.05 27.3401 216.05H137.94C141.475 216.05 144.975 215.354 148.24 214.001C151.506 212.648 154.473 210.665 156.972 208.165C159.471 205.665 161.453 202.697 162.804 199.431C164.156 196.165 164.851 192.665 164.85 189.13V49.25L140.1 49.24Z"
                    fill="#00C650"
                />
            </g>
            <path
                d="M164.85 49.24H140.1C134.632 49.2373 129.389 47.0641 125.522 43.1976C121.656 39.3312 119.483 34.0879 119.48 28.62V0L164.85 49.24Z"
                fill="#00C650"
            />
            <path
                d="M184.37 170.6H59.3301C50.4604 170.6 43.27 177.79 43.27 186.66V223.94C43.27 232.81 50.4604 240 59.3301 240H184.37C193.24 240 200.43 232.81 200.43 223.94V186.66C200.43 177.79 193.24 170.6 184.37 170.6Z"
                fill="#00C650"
            />
            <path
                d="M84.6499 213.37V220.65H77.1201V213.37H84.6499Z"
                fill="white"
            />
            <path
                d="M107 190.58V211.12C107 214.273 106.143 216.697 104.43 218.39C103.474 219.272 102.349 219.952 101.125 220.39C99.8995 220.828 98.5988 221.015 97.3 220.94C95.8776 221.016 94.4541 220.81 93.1118 220.333C91.7696 219.856 90.5351 219.117 89.48 218.16C87.5533 216.3 86.5867 213.633 86.5801 210.16H93.77C93.77 212.97 94.84 214.37 96.96 214.37C98.81 214.37 99.73 213.29 99.73 211.14V190.6L107 190.58Z"
                fill="white"
            />
            <path
                d="M119.06 210.1V220.65H111.79V190.58H123.57C127.137 190.58 129.857 191.463 131.73 193.23C132.678 194.159 133.419 195.278 133.903 196.514C134.387 197.75 134.604 199.074 134.54 200.4C134.567 202.147 134.136 203.871 133.29 205.4C132.419 206.891 131.124 208.088 129.57 208.84C127.698 209.729 125.642 210.16 123.57 210.1H119.06ZM127.14 200.4C127.14 197.733 125.68 196.4 122.76 196.4H119.06V204.23H122.76C125.68 204.257 127.14 202.98 127.14 200.4Z"
                fill="white"
            />
            <path
                d="M161.51 193C163.931 194.821 165.56 197.502 166.06 200.49H158.36C157.839 199.444 157.017 198.576 156 198C154.855 197.32 153.542 196.973 152.21 197C151.176 196.958 150.145 197.144 149.191 197.545C148.237 197.946 147.383 198.552 146.69 199.32C145.223 201.069 144.476 203.311 144.6 205.59C144.6 208.45 145.33 210.647 146.79 212.18C147.611 212.976 148.589 213.592 149.662 213.988C150.735 214.384 151.879 214.552 153.02 214.48C154.652 214.51 156.249 214.008 157.57 213.05C158.919 212.042 159.894 210.614 160.34 208.99H151.15V203.76H166.42V210.95C165.837 212.74 164.913 214.4 163.7 215.84C162.386 217.391 160.752 218.64 158.91 219.5C156.827 220.462 154.554 220.941 152.26 220.9C149.47 220.973 146.71 220.307 144.26 218.97C142.019 217.71 140.194 215.822 139.01 213.54C137.738 211.069 137.102 208.319 137.16 205.54C137.11 202.778 137.746 200.046 139.01 197.59C140.192 195.313 142.009 193.427 144.24 192.16C146.654 190.833 149.376 190.167 152.13 190.23C155.478 190.084 158.779 191.059 161.51 193Z"
                fill="white"
            />
            <path
                d="M104.73 146.41H60.5601C56.236 146.405 52.0905 144.685 49.033 141.627C45.9754 138.57 44.2553 134.424 44.25 130.1V85.9301C44.2553 81.606 45.9754 77.4605 49.033 74.403C52.0905 71.3454 56.236 69.6253 60.5601 69.62H104.73C109.053 69.6253 113.197 71.3457 116.253 74.4036C119.309 77.4614 121.027 81.6069 121.03 85.9301V130.1C121.027 134.423 119.309 138.569 116.253 141.626C113.197 144.684 109.053 146.405 104.73 146.41ZM60.5601 76.83C58.1474 76.8326 55.8342 77.7923 54.1282 79.4983C52.4222 81.2043 51.4626 83.5174 51.46 85.9301V130.1C51.4626 132.513 52.4222 134.826 54.1282 136.532C55.8342 138.238 58.1474 139.197 60.5601 139.2H104.73C107.142 139.197 109.454 138.237 111.158 136.531C112.863 134.825 113.82 132.512 113.82 130.1V85.9301C113.82 83.5183 112.863 81.2052 111.158 79.4989C109.454 77.7926 107.142 76.8326 104.73 76.83H60.5601Z"
                fill="#00C650"
            />
            <path
                d="M117.43 121.7V130.1C117.427 133.467 116.088 136.696 113.707 139.077C111.326 141.458 108.097 142.797 104.73 142.8H60.5601C57.1918 142.8 53.9615 141.462 51.5798 139.08C49.1981 136.698 47.8601 133.468 47.8601 130.1V116C54.9301 114.48 65.7 114 78.77 119.22L86.8701 111.5L92.3899 125.5C92.3899 125.5 93.8699 120.35 98.6499 121.08C103.43 121.81 111.17 124.4 114.48 122.19C115.372 121.675 116.42 121.501 117.43 121.7Z"
                fill="#00C650"
            />
            <path
                d="M101.96 94.95C104.672 94.95 106.87 92.7518 106.87 90.04C106.87 87.3283 104.672 85.13 101.96 85.13C99.2482 85.13 97.05 87.3283 97.05 90.04C97.05 92.7518 99.2482 94.95 101.96 94.95Z"
                fill="#00C650"
            />
        </svg>
    );
};

export const WhatsApp: Icon = (props) => {
    return (
        <svg
            role="img"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            width={32}
            height={32}
            className="fill-primary"
        >
            <path d="m256 0c-141.363281 0-256 114.636719-256 256s114.636719 256 256 256 256-114.636719 256-256-114.636719-256-256-256zm5.425781 405.050781c-.003906 0 .003907 0 0 0h-.0625c-25.644531-.011719-50.84375-6.441406-73.222656-18.644531l-81.222656 21.300781 21.738281-79.375c-13.410156-23.226562-20.464844-49.578125-20.453125-76.574219.035156-84.453124 68.769531-153.160156 153.222656-153.160156 40.984375.015625 79.457031 15.96875 108.382813 44.917969 28.929687 28.953125 44.851562 67.4375 44.835937 108.363281-.035156 84.457032-68.777343 153.171875-153.21875 153.171875zm0 0" />
            <path d="m261.476562 124.46875c-70.246093 0-127.375 57.105469-127.40625 127.300781-.007812 24.054688 6.726563 47.480469 19.472657 67.75l3.027343 4.816407-12.867187 46.980468 48.199219-12.640625 4.652344 2.757813c19.550781 11.601562 41.964843 17.738281 64.816406 17.746094h.050781c70.191406 0 127.320313-57.109376 127.351563-127.308594.011718-34.019532-13.222657-66.003906-37.265626-90.066406-24.042968-24.0625-56.019531-37.324219-90.03125-37.335938zm74.90625 182.035156c-3.191406 8.9375-18.484374 17.097656-25.839843 18.199219-6.597657.984375-14.941407 1.394531-24.113281-1.515625-5.5625-1.765625-12.691407-4.121094-21.828126-8.0625-38.402343-16.578125-63.484374-55.234375-65.398437-57.789062-1.914063-2.554688-15.632813-20.753907-15.632813-39.59375 0-18.835938 9.890626-28.097657 13.398438-31.925782 3.511719-3.832031 7.660156-4.789062 10.210938-4.789062 2.550781 0 5.105468.023437 7.335937.132812 2.351563.117188 5.507813-.894531 8.613281 6.570313 3.191406 7.664062 10.847656 26.5 11.804688 28.414062.957031 1.917969 1.59375 4.152344.320312 6.707031-1.277344 2.554688-5.519531 8.066407-9.570312 13.089844-1.699219 2.105469-3.914063 3.980469-1.679688 7.8125 2.230469 3.828125 9.917969 16.363282 21.296875 26.511719 14.625 13.039063 26.960938 17.078125 30.789063 18.996094 3.824218 1.914062 6.058594 1.59375 8.292968-.957031 2.230469-2.554688 9.570313-11.175782 12.121094-15.007813 2.550782-3.832031 5.105469-3.191406 8.613282-1.914063 3.511718 1.273438 22.332031 10.535157 26.160156 12.449219 3.828125 1.917969 6.378906 2.875 7.335937 4.472657.960938 1.597656.960938 9.257812-2.230469 18.199218zm0 0" />
        </svg>
    );
};
